export enum ActiveShiftTabEnum {
  Today = 'today',
  PendingReview = 'pending-review',
}
